import React, {useState} from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './NavigationBar.css'
import { Link } from 'react-router-dom';

const NavigationBar = () => {

  const [navOpen, setNavOpen] = useState(false);

  const openNav = () => {
    setNavOpen(true);
  };

  const closeNav = (event) => {
    event.preventDefault();
    setNavOpen(false);
  };

  return (
    <>
      <Navbar expand="lg"  className="navigation-bar justify-content-between px-5">
        <Navbar.Brand href="/home">
          <img src="/images/Ace/ace_logo.png" alt="Ace Architect" className="brand-logo" />
          <span className="brand-text">Ace Architects & Associates</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={openNav} />
        <Nav className="ms-auto nav">
          <Nav.Link className="brand-text" href="/home">HOME</Nav.Link>
          <Nav.Link className="brand-text" href="/work">WORK</Nav.Link>
          <Nav.Link className="brand-text" href="/contact-us">CONTACT</Nav.Link>
        </Nav>
      </Navbar>

      <div className={`overlay ${navOpen ? 'open' : ''}`} onClick={closeNav}>
        <a href="/" className="closebtn pt-1 pe-2" onClick={closeNav}>&times;</a>
        <div className="overlay-content">
          <ul>
            <li><Link to="/home">HOME</Link></li>
            <li><Link to="/work">WORK</Link></li>
            <li><Link to="/contact-us">CONTACT</Link></li>
          </ul>
        </div>
      </div>
    </>
  );

}

export default NavigationBar;